import { render, staticRenderFns } from "./VideoGate.vue?vue&type=template&id=6fc94e01&lang=pug&"
import script from "./VideoGate.vue?vue&type=script&lang=js&"
export * from "./VideoGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports